import React from 'react';

const ProcesoDiv = ({ proceso, filaElegida, cambiarFila }) => {

    if (proceso == undefined)
        return null;

    const cssClass = "Proceso" + (filaElegida === proceso.id ? " Selected" : "");

    return (
    <div className={cssClass} onClick={() => cambiarFila(proceso)}>
        <p className="PrimerParrafo">{proceso.numero}</p>
        <p>{proceso.fecha}</p>
    </div>
    );
}

const FilaProcesos = ({ procesos, filaElegida, cambiarFila }) => {

    return (
    <div className="FilaProceso">
      {procesos.map(p => <ProcesoDiv proceso={p} filaElegida={filaElegida} cambiarFila={cambiarFila} />)}
    </div>
    );
}

// La grilla siempre es de 9x9.
const GrillaProcesos = ({ procesosGrilla, filaElegida, cambiarFila }) => {

    const primerFila = procesosGrilla.slice(0, 3);
    const segundaFila = procesosGrilla.slice(3, 6);
    const terceraFila = procesosGrilla.slice(6, 9);

    return (
    <div className="ProcesoContainer">
      <FilaProcesos procesos={primerFila} filaElegida={filaElegida} cambiarFila={cambiarFila}  />
      <br />
      <FilaProcesos procesos={segundaFila} filaElegida={filaElegida} cambiarFila={cambiarFila} />
      <br />
      <FilaProcesos procesos={terceraFila} filaElegida={filaElegida} cambiarFila={cambiarFila} />
    </div>
    );

}

export default GrillaProcesos;